import { UpgradeIds, UpgradeTypes } from '../enums'
import type { Upgrade } from '../../../../types/Upgrade'
import { DepartmentIds } from '../../departments'

const array: Upgrade[] = [
	{
		name: 'MMMMMMMMMMMM EMAILS',
		resource: 'esc_exponent_1',
		id: UpgradeIds.EscExponent1,
		description:
			"Some emails aren't that important. Your team will eat emails at random to reduce the load, though they'll have to deal with the complaints.",
		cost: 100,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Enhanced Sorting Machines',
		resource: 'esc_exponent_2',
		id: UpgradeIds.EscExponent2,
		description:
			'Thanks to modern technology, you can now roll emails through the facility at half the speed.',
		cost: 500,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Not The Bee',
		resource: 'esc_exponent_3',
		id: UpgradeIds.EscExponent3,
		description:
			'Bees now fill the facility, doubling the failure rate of the conveyor belts.',
		cost: 50_000,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Lock everything!',
		resource: 'esc_exponent_4',
		id: UpgradeIds.EscExponent4,
		description:
			'All doors within the facility are permanently locked to enhance physical security. To open them, employees need to call the fire department every time.',
		cost: 10_000_000,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Close on weekdays',
		resource: 'esc_exponent_5',
		id: UpgradeIds.EscExponent5,
		description:
			'The facility will now only operate on weekends, reducing the number of emails processed.',
		cost: 2_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Close on weekends',
		resource: 'esc_exponent_6',
		id: UpgradeIds.EscExponent6,
		description:
			'With the facility closed on every day of the week, nobody knows how this place runs anymore.',
		cost: 500_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	},
	{
		name: 'Wildlife Reserve',
		resource: 'esc_exponent_7',
		id: UpgradeIds.EscExponent7,
		description:
			'Request that the facility be named a wildlife reserve, adversely affecting processing.',
		cost: 100_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Email Sorting Company']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Email Sorting Company']]
		}
	}
]

export default array
